import TransportsUtil from './transports-util';
import Transport from './Transport';
import ComplianceState from './ComplianceState';
import Warning from './Warning';

export default class TransportsController {
    /* @ngInject */
    constructor($log, $modal, $scope, AuthService, ThingsService) {
        this.$log = $log;
        this.$modal = $modal;
        this.$scope = $scope;
        this.AuthService = AuthService;
        this.ThingsService = ThingsService;
        this.showingModal = false;
        this.transports = [];
        this.modalTransport = null;

        this.things = [];
        this.showGraph = true;

        this.toDate = new Date();
        this.toDate.setHours(0, 0, 0);
        this.fromDate = new Date(this.toDate);
        this.fromDate.setDate(this.toDate.getDate() - 3);
        this.toDate.setHours(23, 59, 59);
    }

    $onInit() {
        // const account = this.AuthService.getLocalAccount();
        // console.log(account);
        // this.ThingsService.selectedDomain = account.user.domainPath;

        this.findThingsAndLoadTransports();

        if (this.AuthService.isTransportChief()) {
            this.showGraph = false;
        }

        this.dateWatcher = this.$scope.$watchGroup(['$ctrl.fromDate', '$ctrl.toDate'], (newValue, oldValue) => {
            if (newValue[0] !== oldValue[0] || newValue[1] !== oldValue[1]) {
                this.loadTransports(this.fromDate, this.toDate);
            }
        });
    }

    loadTransports(fromDate, toDate) {
        this.transports = [];
        this.things.forEach((thing) => {
            const thingId = thing._source.thingName;
            const params = {
                fromDate,
                toDate,
                thingId,
            };

            this.ThingsService.getRawHACCPObservations(params)
                .then((data) => {
                    let transport = new Transport();
                    let doorOpenDuringTransportTimestamp;
                    let tempBadTimestamp;
                    let lastDoorCloseTimestamp;
                    let previousDoorOpenState;
                    // let okTempTimestamp;
                    let oldTransportInProgress = true;

                    const state = {};

                    data.hits.hits.forEach((rawObservation) => {
                        const observation = rawObservation._source;
                        const observationTimestamp = Math.round(observation.timestamp / 1000); // Timestamp in seconds

                        // Aggregate state to keep all data in one state variable.
                        Object.entries(observation.state).forEach(([key, val]) => {
                            state[key] = val;
                        });

                        // Handle door close
                        if (previousDoorOpenState === 1 && state.door_open === 0) {
                            // Last door close is used for haccp compliance start
                            lastDoorCloseTimestamp = observationTimestamp;
                        } else if (state.door_open === 0 && !lastDoorCloseTimestamp) {
                            lastDoorCloseTimestamp = observationTimestamp;
                        }
                        previousDoorOpenState = state.door_open;

                        // --- Verkar inte användas.  Kommenterar ut
                        // Handle timestamp for initial reaching of OK temp
                        // if (!okTempTimestamp && (state.box_temperature >= 60 || state.box_temperature <= 8)) {
                        //     okTempTimestamp = observationTimestamp;
                        // } else if (okTempTimestamp && state.box_temperature < 60 && state.box_temperature > 8) {
                        //     okTempTimestamp = null;
                        // }

                        // Ignore further logic for transports that started before start of observation period.
                        if (oldTransportInProgress) {
                            if (state.Virtual_In_Transport === 0) {
                                oldTransportInProgress = false;
                            } else {
                                return;
                            }
                        }

                        // Handle alarms and end of compliance
                        if (transport.start) {
                            if (state.door_open === 1 && TransportsUtil.complianceStartedNotEnded(transport)) {
                                if (!doorOpenDuringTransportTimestamp && !transport.end) {
                                    const warning = new Warning(
                                        'door',
                                        observationTimestamp,
                                        true,
                                        'TRANSPORTS.DOOR.OPENED',
                                        state.latlng,
                                    );
                                    transport.applyWarningIfNotPresent(warning);
                                    transport.complianceEnd = observationTimestamp;
                                    transport.setComplianceState(ComplianceState.Alarm);
                                } else if (!doorOpenDuringTransportTimestamp && transport.end) {
                                    // Transport stopped. Open door ends compliance period
                                    transport.complianceEnd = observationTimestamp;
                                } else if (observationTimestamp > doorOpenDuringTransportTimestamp + 15) {
                                    const warning = new Warning(
                                        'door',
                                        observationTimestamp,
                                        true,
                                        'TRANSPORTS.DOOR.OPEN.TOO.LONG',
                                        state.latlng,
                                    );
                                    transport.applyWarningIfNotPresent(warning);
                                    transport.complianceEnd = observationTimestamp;

                                    transport.setComplianceState(ComplianceState.NoneCompliant);
                                }
                            }

                            if (TransportsUtil.badTemperature(state) && !transport.end && TransportsUtil.complianceStartedNotEnded(transport)) {
                                if (!tempBadTimestamp) {
                                    const warning = new Warning(
                                        'temp',
                                        observationTimestamp,
                                        true,
                                        'TRANSPORTS.TEMP.NOT.OK',
                                        state.latlng,
                                    );
                                    transport.applyWarningIfNotPresent(warning);
                                    transport.complianceEnd = observationTimestamp;
                                    transport.setComplianceState(ComplianceState.Alarm);
                                } else if (TransportsUtil.badTemperature(state) && transport.end) {
                                    // Transport stopped. Bad temp ends compliance period
                                    transport.complianceEnd = observationTimestamp;
                                } else if (observationTimestamp > tempBadTimestamp + 30) {
                                    const warning = new Warning(
                                        'temp',
                                        observationTimestamp,
                                        true,
                                        'TRANSPORTS.TEMP.BAD.TOO.LONG',
                                        state.latlng,
                                    );
                                    transport.applyWarningIfNotPresent(warning);
                                    transport.complianceEnd = observationTimestamp;
                                    transport.setComplianceState(ComplianceState.NoneCompliant);
                                }
                            }
                        }

                        // Handle return to compliance (with warning) for door open state
                        if (doorOpenDuringTransportTimestamp) {
                            if (state.door_open === 0 && observationTimestamp < doorOpenDuringTransportTimestamp + 15) {
                                const warning = new Warning(
                                    'door',
                                    observationTimestamp,
                                    false,
                                    'TRANSPORTS.DOOR.OPEN.OK',
                                    state.latlng,
                                );
                                transport.applyWarningIfNotPresent(warning);
                                transport.setComplianceState(ComplianceState.CompliantWithWarnings);

                                transport.complianceStart = lastDoorCloseTimestamp;
                                doorOpenDuringTransportTimestamp = null;
                            } else if (state.door_open === 0 &&
                                observationTimestamp > doorOpenDuringTransportTimestamp + 15 &&
                                TransportsUtil.complianceStartedNotEnded(transport)
                            ) {
                                const warning = new Warning(
                                    'door',
                                    observationTimestamp,
                                    true,
                                    'TRANSPORTS.DOOR.OPEN.NOT.OK',
                                    state.latlng,
                                );
                                transport.applyWarningIfNotPresent(warning);
                                transport.complianceEnd = observationTimestamp;
                                transport.setComplianceState(ComplianceState.NoneCompliant);
                                doorOpenDuringTransportTimestamp = null;
                            }
                        }

                        // Handle return to compliance (with warning) for temp bad state
                        // TODO: This doesn't catch if temperature should be > 60 but is actually < 8, etc.
                        // TODO: ... But there is no data for what temp the box should be during transport.
                        if (tempBadTimestamp) {
                            if (
                                observationTimestamp < tempBadTimestamp + 30 &&
                                (state.box_temperature < 8 || state.box_temperature > 60)
                            ) {
                                const warning = new Warning(
                                    'temp',
                                    observationTimestamp,
                                    false,
                                    'TRANSPORTS.TEMP.BAD.OK',
                                    state.latlng,
                                );
                                transport.applyWarningIfNotPresent(warning);
                                transport.complianceStart = lastDoorCloseTimestamp;
                                tempBadTimestamp = null;
                                transport.setComplianceState(ComplianceState.CompliantWithWarnings);
                            } else if (
                                observationTimestamp > tempBadTimestamp + 30 &&
                                (state.box_temperature < 8 || state.box_temperature > 60) &&
                                TransportsUtil.complianceStartedNotEnded(transport)
                            ) {
                                const warning = new Warning(
                                    'temp',
                                    observationTimestamp,
                                    true,
                                    'TRANSPORTS.TEMP.BAD.NOT.OK',
                                    state.latlng,
                                );
                                transport.applyWarningIfNotPresent(warning);
                                transport.complianceEnd = observationTimestamp;
                                tempBadTimestamp = null;
                                transport.setComplianceState(ComplianceState.NoneCompliant);
                            }
                        }

                        // Handle start & end of transport
                        if (state.Virtual_In_Transport === 1) {
                            if (!transport.start) {
                                // this.$log.log('transport.start', thingId, observationTimestamp);
                                transport.unitId = thingId;
                                transport.start = observationTimestamp;
                                transport.startTemp = state.box_temperature;

                                if (state.door_open === 1) {
                                    doorOpenDuringTransportTimestamp = observationTimestamp;
                                }

                                if (TransportsUtil.badTemperature(state)) {
                                    tempBadTimestamp = observationTimestamp;
                                }

                                if (!doorOpenDuringTransportTimestamp && !tempBadTimestamp) {
                                    // Villkor för haccp_start (sista dörrstängningen innan start av transport)
                                    transport.complianceStart = lastDoorCloseTimestamp;
                                    transport.setComplianceState(ComplianceState.Compliant);
                                }
                            }
                        } else if (state.Virtual_In_Transport === 0 && transport.start && !transport.end && state.door_open === 0) {
                            transport.end = observationTimestamp;
                        } else if (state.Virtual_In_Transport === 0 && transport.end) {
                            // If not compliance ended by any warning, end the compliance period when Door opens after transport ended.
                            if (TransportsUtil.complianceStartedNotEnded(transport) && state.door_open === 0) {
                                transport.complianceEnd = observationTimestamp;
                            }

                            // Check duration compliance
                            if (TransportsUtil.haccpCompliantWarningDuration(lastDoorCloseTimestamp, transport.complianceEnd)) {
                                const warning = new Warning(
                                    'door',
                                    observationTimestamp,
                                    false,
                                    'TRANSPORTS.LONG.OK',
                                    state.latlng,
                                );
                                transport.applyWarningIfNotPresent(warning);
                                transport.setComplianceState(ComplianceState.CompliantWithWarnings);
                            }
                            if (TransportsUtil.haccpNotCompliantDuration(lastDoorCloseTimestamp, transport.complianceEnd)) {
                                const warning = new Warning(
                                    'door',
                                    observationTimestamp,
                                    true,
                                    'TRANSPORTS.LONG.NOT.OK',
                                    state.latlng,
                                );
                                transport.applyWarningIfNotPresent(warning);
                                transport.setComplianceState(ComplianceState.NoneCompliant);
                            }

                            // Add transport when within limits
                            if (TransportsUtil.isTransportDurationWithinLimits(transport)) {
                                this.transports.push(
                                    Object.assign(Object.create(Object.getPrototypeOf(transport)), transport),
                                );
                            }

                            transport = new Transport();
                            doorOpenDuringTransportTimestamp = null;
                            tempBadTimestamp = null;
                            lastDoorCloseTimestamp = null;
                            previousDoorOpenState = null;
                            // okTempTimestamp = null;
                            oldTransportInProgress = true;
                        }
                    });
                })
                .then(() => {
                    // TODO: This should be done just once after all transports are loaded, but couldn't get it to work.
                    this.transports = this.transports.sort((a, b) => (a.start < b.start ? 1 : -1));

                    this.transports.forEach((t) => {
                        t.unitName = this.things.find(s => s._id === t.unitId)._source.label;
                    });
                });
        });
    }

    filterOnDomain(domainId) {
        this.transports = [];
        this.things = [];
        this.ThingsService.selectedDomain = domainId;
        this.findThingsAndLoadTransports();
    }

    findThingsAndLoadTransports() {
        this.transports = [];
        this.ThingsService.getThings()
            .then((response) => {
                this.things = response.hits.hits;
            })
            .then(() => {
                this.loadTransports(new Date(this.fromDate), new Date(this.toDate));
            });
    }

    getThings() {
        this.transports = [];
        this.things = [];
        this.ThingsService.getThings().then((response) => {
            this.things = response.hits.hits;
        });
    }

    showModal(transport) {
        this.modalTransport = transport;
        this.showingModal = true;
    }

    hideModal() {
        this.showingModal = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/transports/transports.controller.js